import React from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonPrimary } from '../../../../../utils/Button';
import { GetDate, GetTime } from '../../../../../utils/Show';

function Info({ title, value }) {
    return (
        <div className="flex items-center gap-x-4">
            <div className="w-[80px]">
                <p className="text-primary-700 text-sm">{title}</p>
            </div>
            :
            <div className="flex-1">
                <p className="text-primary text-sm">
                    <span> {value}</span>
                </p>
            </div>
        </div>
    );
}

function InvoiceAuthorizeInfo({ invoiceData }) {
    const { openModal } = useTemplate();

    return (
        <div className="">
            <div className="mb-4 flex items-start justify-between">
                <h2 className="text-primary text-xl font-normal">Authorize Info</h2>
            </div>

            <div className="flex flex-col items-start">
                {invoiceData?.authorizedBy === 0 ? (
                    <div className="flex items-center gap-x-2">
                        <ButtonPrimary
                            title="Authorize Invoice"
                            onClick={() => openModal('invoice_authorize', invoiceData)}
                            disabled={
                                invoiceData?.status === 'canceled' || invoiceData?.authorizedBy > 0
                            }
                            className="bg-[#198754]"
                        />
                        <ButtonPrimary
                            title="Reject Invoice"
                            onClick={() => openModal('invoice_reject', invoiceData)}
                            disabled={
                                invoiceData?.status === 'canceled' || invoiceData?.authorizedBy > 0
                            }
                            className="bg-[#dc3545] hidden"
                        />
                    </div>
                ) : (
                    <div className="w-full">
                        <Info title="User Name" value={invoiceData?.authorizedByName || 'N/A'} />
                        <Info
                            title="Time"
                            value={
                                <span className="text-sm">
                                    {GetDate(invoiceData?.authorizedTime || 0)}{' '}
                                    {GetTime(invoiceData?.authorizedTime || 0)}
                                </span>
                            }
                        />
                        <Info
                            title="Note"
                            value={
                                invoiceData?.authorizedNote?.length === 0
                                    ? 'N/A'
                                    : invoiceData?.authorizedNote
                            }
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default InvoiceAuthorizeInfo;
